<template>
  <div>
    <h-btn flat color="primary" @click="display=true">Add A Graph</h-btn>
    <modal v-if="display" @close="display=false" @submit="save" btn="Save" title="Add Graph">
      <h-input v-model="name" label="Graph Name" outline/>
    </modal>
  </div>
</template>

<script>
import modal from "@/components/modal/default";
import dataStore from "@/services/api/store";
import snackbarHub from "@/services/hubs/snackbar";
const PULSE_SURVEY_DIMENSION_STORE = "CoachPulseSurveyDiminsion";

export default {
  props: ["pulseSurvey"],
  components: {
    modal
  },
  data() {
    return {
      display: false,
      name: "",
      saving: false
    };
  },
  methods: {
    reset() {
      this.display = false;
      this.name = "";
    },
    save() {
      this.saving = true;
      let dimension = { name: this.name, pulse_survey: [this.pulseSurvey] };
      dataStore
        .create(PULSE_SURVEY_DIMENSION_STORE, dimension)
        .then(dimension => {
          snackbarHub.update("Saved");
          this.$emit("created", dimension);
          this.reset();
        })
        .finally(() => (this.saving = false));
    }
  }
};
</script>

<style>
</style>
